import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import message from 'antd/lib/message';
import Popconfirm from 'antd/lib/popconfirm';
import Spin from 'antd/lib/spin';

import ModalComponent from './modal_component'
import AuthenticationService from '../../../service/authentication_service';

import AppService from '../../../service/app_service';

class SecureTransactionComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dashboard: props.dashboard,
            showNav: false,
            showModal: false,
            showUserMenu: false,
            showMobileSubMenu:false,
            amount: 1,
            rate: 1,
            role: 'seller',
            loading: false,
        };
    }

    componentDidMount() {
        if (!AuthenticationService.getToken()) {
            this.props.history.push("/");
            message.error('Kindly login');
        }
    }
    logout = () => {
        AuthenticationService.clearLocalstorage();
        this.props.history.push("/signin");
    }
    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });

    }

    postSellRequest = () => {
        if (!AuthenticationService.getToken()) {
            message.error("Kindly login first.")
        }
        else if (this.state.amount && this.state.description && this.state.role && this.state.asset && this.state.partnerMobileNumber) {
            this.setState({
                loading: true, responseMessage: ''
            });
            let data = {};
            data.asset = this.state.asset;
            data.name = this.state.asset;
            data.description = this.state.description;
            data.amount = parseFloat(this.state.amount.replace(/,/g, ''));
            data.role = this.state.role;
            data.rate = this.state.rate && this.state.rate > 0 ? this.state.rate : 1;
            data.partnerMobileNumber = this.state.partnerMobileNumber;
            data.partnerEmailAddress = this.state.partnerEmailAddress;
            data.myEmailAddress = AuthenticationService.getEmail();
            data.type = "TRANSACTION";
            AppService.postSellRequest(data).then(rec => {

                if (rec.code) {
                    message.error(rec.description)
                } else {
                    this.setState({
                        coins: rec.data, amount: 0, rate: 1, description: '', asset: '', loading: false, partnerMobileNumber: '', responseMessage: rec.description
                    });
                    message.success("Transaction uploaded successfully")
                    this.props.history.push("/transaction/detail/" + rec.ref)
                    //this.getOrders();
                }

            })
        } else {
            if (!this.state.amount) {
                message.error('Amount is missing')
            } else if (!this.state.description) {
                message.error('Description is missing')
            } else if (!this.state.role) {
                message.error('Role is missing')
            } else if (!this.state.asset) {
                message.error('Product name is missing')
            } else if (!this.state.partnerMobileNumber) {
                message.error('Phone number is missing')
            }


        }

    }
    render() {
        const { showNav, showModal, showUserMenu, role, responseMessage, loading,showMobileSubMenu } = this.state;
        return (
            <div>
                <a onClick={() => this.setState({ showModal: true })} className="btn btn-sm btn-outline btn-light"><em className="text-primary ti ti-files" /><span>Secure A Transaction</span></a>
                {showModal && <ModalComponent show={showModal} closeModal={() => this.setState({ showModal: !this.state.showModal })} title="Secucure A Transaction" >
                    <div>

                        <Spin spinning={loading}>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Amount</label>
                                        <input type="number" name="amount" className="input-bordered" placeholder="Amount" onChange={this.handleChange} />
                                    </div>

                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">I'm</label>
                                        <div className="select-wrapper">
                                            <select name="role" className="input-bordered" value={role} onChange={this.handleChange}>
                                                <option value="seller">Selling (Seller)</option>
                                                <option value="buyer">Buying (Buyer)</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Asset</label>
                                        <input type="text" name="asset" value={this.state.asset} className="input-bordered" placeholder="" onChange={this.handleChange} />
                                    </div>






                                    {/* <div className="input-item input-with-label">
                                <label className="input-item-label">File Upload</label>
                                <div className="relative">
                                    <em className="input-file-icon fas fa-upload" />
                                    <input type="file" className="input-file" id="file-01" />
                                    <label htmlFor="file-01">Choose a file</label>
                                </div>
                            </div> */}
                                </div>
                                <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">{role === "seller" ? "Buyer's" : "Seller's"} phone number</label>
                                        <input type="phone" name="partnerMobileNumber" value={this.state.partnerMobileNumber} className="input-bordered" placeholder="Phone number" onChange={this.handleChange} />

                                    </div>

                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">{role === "seller" ? "Buyer's" : "Seller's"} email address</label>
                                        <input type="phone" name="partnerEmailAddress" value={this.state.partnerEmailAddress} className="input-bordered" placeholder="Email address" onChange={this.handleChange} />

                                    </div>
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Terms</label>
                                        <textarea type="text" name="description" value={this.state.description} className="input-bordered" placeholder="" onChange={this.handleChange} />
                                    </div>

                                </div>
                                <div className="col-md-12">
                                    <p>{(responseMessage)}</p>
                                    {<Popconfirm
                                        title="Are you sure to submit this transaction?"
                                        onConfirm={this.postSellRequest}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <button type="submit" disabled={loading} name="submit" className="btn btn-success btn-block">Safeguard this transaction</button>
                                    </Popconfirm>}
                                </div>

                            </div>
                        </Spin>




                    </div>
                </ModalComponent>}
            </div>
        );
    }
}

export default withRouter(SecureTransactionComponent);
